import { jsxs as o, jsx as r } from "react/jsx-runtime";
import t from "./desktop-components/desktop-header/desktop-header.js";
import a from "./mobile-components/mobile-header/mobile-header.js";
const s = (e) => /* @__PURE__ */ o("header", { children: [
  /* @__PURE__ */ r(t, { ...e }),
  /* @__PURE__ */ r(a, { ...e })
] });
export {
  s as HeaderV2,
  s as default
};
